import { AuthEvent } from '../types';

interface EventLogPanelProps {
  events: AuthEvent[];
}

export const EventLogPanel = ({ events }: EventLogPanelProps) => {
  const formatTime = (date: Date) => {
    return date.toLocaleTimeString('en-US', {
      hour12: false,
      hour: '2-digit',
      minute: '2-digit',
      second: '2-digit',
      fractionalSecondDigits: 3,
    });
  };

  const getStatusIcon = (status: AuthEvent['status']) => {
    switch (status) {
      case 'info':
        return '🔵';
      case 'error':
        return '🔴';
      case 'success':
        return '✅';
      default:
        return '⚪';
    }
  };

  const getStatusClass = (status: AuthEvent['status']) => {
    switch (status) {
      case 'info':
        return 'text-blue-400';
      case 'error':
        return 'text-red-400';
      case 'success':
        return 'text-green-400';
      default:
        return 'text-gray-400';
    }
  };

  return (
    <div className='fixed top-0 left-0 right-0 bg-black/90 backdrop-blur-sm border-b border-gray-800 p-4 z-50 max-h-48 overflow-y-auto'>
      <div className='max-w-4xl mx-auto'>
        <h3 className='text-sm font-semibold text-gray-300 mb-2'>📋 Authentication Flow Log</h3>
        <div className='space-y-1 font-mono text-xs'>
          {events.length === 0 && <div className='text-gray-500'>No events yet...</div>}
          {events.map((event, index) => (
            <div key={index} className='flex items-start gap-2'>
              <span className='text-gray-600 shrink-0'>{formatTime(event.timestamp)}</span>
              <span className='shrink-0'>{getStatusIcon(event.status)}</span>
              <span className='text-gray-400 shrink-0 min-w-[120px]'>[{event.stage}]</span>
              <span className={getStatusClass(event.status)}>{event.message}</span>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};
